"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiCallError = void 0;
class ApiCallError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, ApiCallError.prototype);
    }
}
exports.ApiCallError = ApiCallError;
